<header class="app-topbar">
  <div class="app-topbar__inner">
    <div class="app-topbar__brand">
      <div>
        <p class="brand-kicker">The Mailbox Club</p>
        <p class="brand-title">Indonesia</p>
      </div>
    </div>
    <div class="app-topbar__profile">
      <button
        class="app-topbar__profile-button"
        type="button"
        aria-label="Profile"
        aria-haspopup="menu"
        [attr.aria-expanded]="isMenuOpen()"
        aria-controls="topbar-profile-menu"
        (click)="toggleMenu($event)">
        <ng-glyph class="app-topbar__profile-icon" name="person"></ng-glyph>
      </button>
      @if (isMenuOpen()) {
      <div class="app-topbar__menu" id="topbar-profile-menu" role="menu">
        <div class="app-topbar__menu-user">
          <app-avatar [imageUrl]="user().imageUrl" [name]="user().name" size="lg"></app-avatar>
          <div class="app-topbar__menu-user-details">
            <p class="app-topbar__menu-name">{{ user().name }}</p>
            <p class="app-topbar__menu-email">{{ user().email }}</p>
            <p class="app-topbar__menu-role">{{ user().role.name }}</p>
          </div>
        </div>
        <div class="app-topbar__menu-divider"></div>
        <div class="app-topbar__menu-actions">
          <app-button class="app-topbar__menu-action" variant="simple" type="button" (click)="profile()">
            <ng-glyph class="app-topbar__menu-action-icon" name="person"></ng-glyph>
            Profile
          </app-button>
          <app-button class="app-topbar__menu-action" variant="simple" type="button" (click)="logout()">
            <ng-glyph class="app-topbar__menu-action-icon" name="logout"></ng-glyph>
            Logout
          </app-button>
        </div>
      </div>
      }
    </div>
  </div>
</header>
